import checkRequiredInputs from "./check-required-inputs";

const Footer = () => {
  const footerForms = document.querySelectorAll(".footer__form");

  if (footerForms.length > 0) {
    footerForms.forEach((footerForm) => {
      const requiredInputs = [...footerForm.querySelectorAll('.footer__input'), ...footerForm.querySelectorAll('input[type="checkbox"]')];
      const footerFormBtn = footerForm.querySelector(".footer__form-btn");

      if (requiredInputs.length > 0) {
        requiredInputs.forEach(requiredInput => {
          requiredInput.addEventListener('input', () => checkRequiredInputs(requiredInputs, footerFormBtn));
        });
      };
    });
  }
}

export default Footer;



